import { render, staticRenderFns } from "./RedactorDetails.vue?vue&type=template&id=6c2799bc&"
import script from "./RedactorDetails.vue?vue&type=script&lang=js&"
export * from "./RedactorDetails.vue?vue&type=script&lang=js&"
import style0 from "./RedactorDetails.vue?vue&type=style&index=0&id=6c2799bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports